module.exports = __webpack_public_path__ + "img/IMG_0548.45f42b3e.jpg";